export function checkIfMessageIsLink(message: string) {
	return /(?:https?|ftp):\/\/[\n\S]+/i.test(message);
}

export function handleRepliedMessageScroll(repliedMessageParentId?: string) {
	const chatViewStore = App.state.rootStore.chatViewStore;

	if (repliedMessageParentId) {
		const element = document.getElementById(repliedMessageParentId);
		if (element) {
			element.scrollIntoView({ block: "center", behavior: "smooth" });

			element.classList.add("is-focused");

			chatViewStore.setReplyScrollingLoader(false);

			setTimeout(() => {
				element.classList.remove("is-focused");
			}, 1000);
		} else {
			handleScrollToLastRenderedMessage(repliedMessageParentId);
		}
	}
}

export function handleScrollToLastRenderedMessage(
	repliedMessageParentId: string
) {
	const chatViewStore = App.state.rootStore.chatViewStore;

	chatViewStore.setReplyScrollingLoader(true);

	const element = document.getElementById("reply-scroll-div");
	if (element) {
		element.scrollIntoView({ block: "end", behavior: "smooth" });
	}
	setTimeout(() => {
		if (repliedMessageParentId) {
			const element = document.getElementById(repliedMessageParentId);
			if (!element) {
				handleRepliedMessageScroll(repliedMessageParentId);
			} else {
				handleRepliedMessageScroll(repliedMessageParentId);
			}
		}
	}, 1200);
}

export function chatScrollToBottom(scrollDivId?: string) {
	const element = document.getElementById(scrollDivId || "bottom-scroll-div");
	if (element) {
		element.scrollIntoView({
			block: "start",
			behavior: "smooth",
		});
	}
}

export function downloadFile(fileName: string, fileUrl: string) {
	const link = document.createElement("a");
	link.setAttribute("download", fileName);
	link.href = fileUrl;
	document.body.appendChild(link);
	link.click();
	link.remove();
}
